import React from 'react';
import tour from '../../images/Capture2.PNG'

const Gtour = () => {
    return (
        <div 
        data-aos="zoom-in"
        data-aos-duration="3000"
        className="bg-gray-300 ">
           <h1 className="text-4xl font-semibold text-red-500">G Tour</h1>
           <div className="grid lg:grid-cols-3 px-5 mt-3">
               <div >
                   <img className="px-3" src={tour} alt="" />
               </div>
               <div>
                   <img className="px-3" src="https://i.ibb.co/GH4yJ5W/g-order.png" alt="" />
               </div>
               <div>
                   <img className="px-3" src="https://i.ibb.co/k4drWNF/screencapture-g-tour-1abb5-firebaseapp-addnew-2021-11-30-20-42-44-1.png" alt="" />
               </div>
           </div>

           <div className="mt-10">
               
               <p className="text-justify text-xl px-20  mb-5"> A full-stack single-page touring web app. Login system with firebase and private routes. Users can book packages and see their purchase records on the order page. Admin panel, where admin can do CRUD operations. </p>
               
               <button className="px-2 py-1 bg-gray-400 ">React.js</button> 
        <button className="px-2 py-1 bg-gray-400 mx-1">React Tailwind</button>
        <button className="px-2 py-1 bg-gray-400 mx-1">Node.js</button>
        <button className="px-2 py-1 bg-gray-400 mx-1">Express.js</button>
        <button className="px-2 py-1 bg-gray-400 mx-1">MongoDB</button>
        <button className="px-2 py-1 bg-gray-400 mx-1 mt-2">Firebase Authentication</button>
           </div>

           <div className="mt-5 pb-10"> 
               <button className="bg-gray-600 rounded px-5 py-2  text-white text-xl mx-2"> <a href="https://g-tour-1abb5.firebaseapp.com/">Live Preview</a> </button>
               <button className="bg-gray-600 rounded px-5 py-2  text-white text-xl mx-2"> <a href="https://github.com/Joy10311/G-Tour-Client">Client Code</a> </button>
               <button className="bg-gray-600 rounded px-5 py-2  text-white text-xl my-2 mx-2"> <a href="https://github.com/Joy10311/G-Tour-Server">Server Code</a> </button>
           </div>
        </div>
    );
};

export default Gtour;